export default __webpack_public_path__ + "static/preview-e33a2293d6687f8c16a511aae12e51ac.gif";